import { useState, useEffect, useCallback } from 'react';
import { APICore } from '../helpers/api/apiCore';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  
  const api = new APICore();

  const checkAuth = useCallback(async () => {
    setIsLoading(true);
    try {
      const authResult = await api.isUserAuthenticated();
      setIsAuthenticated(authResult);
      
      if (authResult) {
        const userData = api.getLoggedInUser();
        setUser(userData?.user || null);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Authentication check failed:', error);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const login = useCallback(async (credentials) => {
    try {
      // This should be implemented based on your login API
      const response = await api.create('/auth/login', credentials);
      if (response.data) {
        api.setLoggedInUser(response.data);
        await checkAuth();
        return { success: true, data: response.data };
      }
    } catch (error) {
      console.error('Login failed:', error);
      return { success: false, error: error.message };
    }
  }, [checkAuth]);

  const logout = useCallback(() => {
    api.setLoggedInUser(null);
    setIsAuthenticated(false);
    setUser(null);
    setIsLoading(false);
  }, []);

  const refreshAuthState = useCallback(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout,
    refreshAuthState,
    checkAuth
  };
};

export default useAuth;
